module.exports = __webpack_public_path__ + "2acb60f2/img/settings-icon.121d9519.svg";